export const brand = {
  black: '#000000',
  /** Hex: #231f20 */
  nearlyBlack: '#231f20',
  white: '#ffffff',
  red: {
    /** Hex: #db011c */
    base: '#db011c',
    /** Rgb: 219, 1, 28 */
    baseRgb: '219, 1, 28',
    /** Hex: #ab0116 */
    dark: '#ab0116',
    /** Hex: #840111 */
    darkest: '#840111',
    /** Hex: #970000 */
    gradient1: '#970000',
    /** Hex: #510000 */
    gradient2: '#510000',
    /** Hex: #BF7982 */
    light: '#BF7982',
  },
  green: {
    base: '#00A600',
    light: '#0CDE00',
    dark: '#008F00',
    darker: '#006800',
    darkest: '#005800',
  },
  orange: {
    base: '#F0803B',
  },
  grey: {
    steel: '#C6C6C6',
    97: 'hsl(0, 0%, 97%);',
    95: 'hsl(0, 0%, 95%);',
    90: 'hsl(0, 0%, 90%);',
    85: 'hsl(0, 0%, 85%);',
    80: 'hsl(0, 0%, 80%);',
    78: 'hsl(0, 0%, 78%);',
    75: 'hsl(0, 0%, 75%);',
    70: 'hsl(0, 0%, 70%);',
    65: 'hsl(0, 0%, 65%);',
    60: 'hsl(0, 0%, 60%);',
    55: 'hsl(0, 0%, 55%);',
    50: 'hsl(0, 0%, 50%);',
    45: 'hsl(0, 0%, 45%);',
    40: 'hsl(0, 0%, 40%);',
    35: 'hsl(0, 0%, 35%);',
    30: 'hsl(0, 0%, 30%);',
    25: 'hsl(0, 0%, 25%);',
    20: 'hsl(0, 0%, 20%);',
    15: 'hsl(0, 0%, 15%);',
    10: 'hsl(0, 0%, 10%);',
    '05': 'hsl(0, 0%, 5%);',
  },
};

export default brand;
